import { render } from "./SubTopic.vue?vue&type=template&id=9e6c779c&scoped=true"
import script from "./SubTopic.vue?vue&type=script&lang=js"
export * from "./SubTopic.vue?vue&type=script&lang=js"

import "./SubTopic.vue?vue&type=style&index=0&id=9e6c779c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9e6c779c"

export default script